import React, { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import { Container, Row, Col } from 'react-bootstrap';
import { FaBuilding, FaHourglassHalf, FaEnvelope, FaStar ,FaBars,FaTimes} from 'react-icons/fa';

const DashboardLayout = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <>
    <button
    className="mobile-sidebar-toggle-btn d-md-none"
    style={{
      position: 'fixed',
      top: 20,
      left: 20,
      zIndex: 2100,
      background: 'white',
      border: 'none',
      borderRadius: 8,
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      fontSize: 28,
      width: 48,
      height: 48,
      display: isMobile ? 'block' : 'none',
    }}
    onClick={() => setIsMobileSidebarOpen(true)}
  >
    <FaBars />
  </button>
   {/* Sidebar Overlay for Mobile */}
   {isMobileSidebarOpen && isMobile && (
    <>
      <div
        className="sidebar-backdrop"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          background: 'rgba(0,0,0,0.4)',
          zIndex: 1999,
        }}
        onClick={() => setIsMobileSidebarOpen(false)}
      />
      <div
        className="sidebar-overlay"
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          height: '100vh',
          width: '80vw',
          maxWidth: 300,
          background: '#222',
          color: 'white',
          zIndex: 2000,
          boxShadow: '2px 0 16px rgba(0,0,0,0.2)',
          transition: 'transform 0.3s',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <button
          style={{
            background: 'none',
            border: 'none',
            color: 'white',
            fontSize: 28,
            alignSelf: 'flex-end',
            margin: 16,
            zIndex: 2001,
          }}
          onClick={() => setIsMobileSidebarOpen(false)}
        >
          <FaTimes />
        </button>
        <Sidebar
          collapsed={false}
          onLinkClick={() => setIsMobileSidebarOpen(false)}
        />
      </div>
    </>
  )}


    <Container fluid>
      <Row>
        {/* Desktop Sidebar (hidden on mobile) */}
        {!isMobile && (
          <Col md={2} className="p-0">
            <Sidebar />
          </Col>
        )}
        <Col md={!isMobile ? 10 : 12} className="p-4">
          {children}
        </Col>
      </Row>
    </Container>
    </>


  );
};

export default DashboardLayout;
